export enum TagType {
    Test = "Test",
    Live = "Live",
    Demo = "Demo"
}
